import React from 'react';
import '../styles/Team.css';

import T1 from '../assets/T1.jpg';
import T2 from '../assets/T2.jpg';
import T3 from '../assets/T3.jpg';
import T4 from '../assets/T4.jpg';
import T5 from '../assets/T5.jpg';
import T6 from '../assets/T6.jpg';

const Team = () => {
  const teamMembers = [
   {
  id: 1,
  name: 'Daniel Anteneh',
  position: 'Founder and CEO',
  description: 'Visionary leader with 15+ years in international trade, specializing in Ethiopia-China business relations and strategic market expansion.',
  image: T1,
  telegram: 'https://t.me/Daniy3l',
  whatsapp: 'https://wa.me/message/X6KLKUUKNBGJE1'
},
{
  id: 2,
  name: 'H/meskel Yihun',
  position: 'Sales Director & Tech Lead',
  description: 'Combining digital innovation with sales strategy to create seamless customer experiences and drive business growth through technology.',
  image: T2,
  telegram: 'https://t.me/HM_Yihun',
  whatsapp: 'https://wa.me/qr/KYQN5CQPL5Z4O1'
},

    {
      id: 3,
      name: 'Elias Gebreselassie',
      position: 'Logistics Operations Director',
      description: 'Expert in global supply chain management, customs regulations, and ensuring efficient cross-border logistics operations.',
      image: T3,
      telegram: '#',
      whatsapp: '#'
    },
    {
      id: 4,
      name: 'Lily Chen',
      position: 'Quality Assurance Manager',
      description: 'Dedicated to excellence in product quality through rigorous inspection protocols and continuous improvement processes.',
      image: T4,
      telegram: '#',
      whatsapp: '#'
    },
    {
      id: 5,
      name: 'Amina Yusuf',
      position: 'International Partnerships Coordinator',
      description: 'Building bridges between Ethiopian enterprises and global partners through strategic networking and relationship management.',
      image: T5,
      telegram: '#',
      whatsapp: '#'
    },
    {
      id: 6,
      name: 'Mulugeta Tadesse',
      position: 'Finance & Compliance Director',
      description: 'Ensuring financial integrity and regulatory compliance across all international trade transactions and business operations.',
      image: T6,
      telegram: '#',
      whatsapp: '#'
    }
  ];

  return (
    <div className="page team-page">
      <header className="team-header">
        <h1>Trusted Quality Control Services</h1>
        <p>Meet the dedicated experts driving our seamless international trade solutions.</p>
      </header>

      <section className="team-grid">
        {teamMembers.map((member) => (
          <div key={member.id} className="team-card">
            <div className="profile-image-container">
              <img 
                src={member.image} 
                alt={member.name}
                className="profile-image"
              />
            </div>
            
            <div className="team-info">
              <h3 className="member-name">{member.name}</h3>
              <p className="member-position">{member.position}</p>
              <p className="member-description">{member.description}</p>
              
              <div className="social-links">

                {/* Telegram icon (replaces LinkedIn) */}
                <a href={member.telegram} className="social-link telegram" aria-label="Telegram">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9.04 15.314l-.396 5.578c.568 0 .813-.244 1.108-.537l2.663-2.55 5.518 4.027c1.011.556 1.728.263 1.993-.934l3.61-16.892h.001c.322-1.497-.54-2.083-1.524-1.733L1.64 9.233c-1.447.562-1.431 1.37-.262 1.74l5.577 1.74 12.94-8.223c.609-.37 1.165-.165.708.205"/>
                  </svg>
                </a>

                {/* WhatsApp icon */}
                <a href={member.whatsapp} className="social-link whatsapp" aria-label="WhatsApp">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.189-1.248-6.189-3.515-8.464"/>
                  </svg>
                </a>

              </div>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Team;